import { Menu } from "../menu";

export enum PerfilSituacao {
  ATIVO = "A",
  INATIVO = "I",
}

export interface Perfil {
  readonly id?: number | null;
  readonly nome?: string | null;
  readonly situacao?: PerfilSituacao | null;
  readonly menus?: Menu[] | null;
}
